<template>
  <div id="app">
    <div class="PageBackground"></div>
    <!--------------------------------- V ---------->


    <div id="page" class="Screen" style="position: relative;background:#fff0;">
      <page-header></page-header>
      <div id="main">
        <div class="Screen">
          <router-view></router-view>
        </div>
        <page-footer></page-footer>
      </div>
    </div>
  </div>
</template>

<script>
//import VConsole from 'vconsole';

export default {
  data() {
    return {
    }
  },
  mounted() {
  //  new VConsole()
  }
}
</script>

<style>
body {
  margin: 0;
  overflow-x: hidden;
}

hr {
  height: 1px;
  border: none;
  background: #606;
}

#app {
  display: flex;
  flex-direction: column;
  align-items: center;
}

input[type=button] {
  font-size: 30px;
  line-height: 60px;
  background: #fa0;
  border: none;
  color: #fff;
  padding: 0px 30px;
}
input[type=button].SellOut{
   background: #866!important;   
}

.Screen {
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.fieldset>legend {
  font-size: 22px;
  color: #333333;
  font-weight: bold;
  margin: 5px;
  line-height: 25px;
  display: flex;
  align-items: center;
}


.Icon {
  width: 20px;
  height: 20px;
  margin: 5px;
}

a,
a:visited {
  color: #000;
  text-decoration: none;
}

a:hover {
  color: #515;
}


fieldset {
  border: none;
}

nav {
  padding: 30px 0;
}

nav a {
  margin: 0px 30px;
}

section {
  display: flex;
  flex-wrap: wrap;
}

.GoldButton {
  font-size: 13px;
  padding: 0 50px;
  line-height: 40px;
  border-radius: 20px;
  color: #93806f !important;
  border: 1px solid #93806f;
}

.GoldButton:hover {
  color: #fff !important;
  background-color: #93806f;
}

b {
  color: #f80;
}

s {
  color: #662;
}

.Panel {
  flex-grow: 1;
  background: #fff;
  box-shadow: 1px 1px 3px #aaa;
  margin: 5px;
  min-height: 500px;
  padding: 22px;
  border-radius: 5px;
}

.Mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #0009;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Dialog {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  position: relative;
}

legend:before {
  content: "";
  width: 5px;
  height: 30px;
  background: #2727be;
  margin-right: 5px;
}

a.A {
  color: blueviolet;
  text-decoration: underline;
  cursor: pointer;
}

.Submit {
  background: orange;
  border-radius: 10px;
  color: #fff;
}

@media screen and (orientation: landscape) {

  .PageBackground {
    position: fixed;
    top: 0;
    left: 0;
    background: #fff;/*url(@/assets/background.jpg);*/
    background-size: 125.2vw 65.25vw;
    background-position: 100% 0%;
    width: 100%;
    height: 100%;
  }

  #page {
    background: #fffc !important;
  }

  .Board {
    width: 1200px !important;
    display: flex;
    margin: 10px 0;
  }


  .HeaderV {
    display: none !important;
  }

  .Banner {
    width: 100vw;
    height:24.9vw;
    margin: 0;
  }

  .Category {
    margin: 20px;
    width: 80px;
    height: 80px;
  }

  .Summary p {
    width: 1200px;
  }

  .MenuV {
    display: none;
  }

  .demo-form {
    margin: 20px auto;
  }

  .Submit {
    width: 200px;
  }
}

@media screen and (orientation: portrait) {

  html,
  body,
  #app {
    width: 100% !important;
    height: 100% !important;
    overflow: hidden;
  }

  .PageBackground {
    position: fixed;
    top: 0;
    left: 0;
    background-size: 300vh 100vh;
    background-position: -100vh 0%;
    width: 100%;
    height: 100%;
  }

  .Board {
    width: 100vw !important;
    display: flex;
    margin: 0;
  }

  .HeaderH {
    display: none !important;
  }

  .HeaderV {
    width: 100vw;
    margin: 0;
  }

  .HeaderV * {
    position: static;
  }
 .Banner {
    width: 100vw;
    height: 24.9vw;
    margin: 0;
  }
  #page {
    height: 100%;
    width: 100vw;
    background: #fffd !important;
  }

  #main {
    width: 100vw;
    flex-grow: 1;
    overflow-y: auto;

    overflow-x: hidden;
  }

   legend {
    margin-left: 5px;
  }

   legend:before {
    content: "";
    width: 5px;
    height: 25px;
    background: #2727be;
    margin-right: 5px;
  }

  footer {
    display: none !important;
  }

  .Category {
    width: 15vw;
    height: 15vw;
    margin: 2vw;
  }

  .Summary p {
    font-size: 20px !important;
  }

  hr.Screen {
    display: none;
  }

  .Panel {
    box-shadow: none;
    padding: 0;
    margin: 0;
  }

  .el-dialog {
    margin: 5vw;
    width: 90vw !important;
  }

  .Submit {
    width: 90vw;
    margin: 5vw;
  }

  .demo-form .el-form-item {
    display: flex !important;
    flex-direction: column;
  }

  .demo-form .el-form-item__label {
    text-align: left;
  }

  .demo-form .el-col-3 {
    word-break: keep-all;

  }

  .demo-form .el-form-item__content {
    margin: 0 !important;
  }
  b,s {
    font-size: 3.5vw;
}

}
</style>